import request from '@/utils/request-axios'
import fileRequest from '@/utils/fileRequest'
import api from '@/utils/api'


//省市区
export function getCity() {
  return request(`${api.getCity}`, {
    loading: true,
    method: 'get',
  });
}

//公司list
export function getCompanyList(params) {
  return request(`${api.getCompanyList}`, {
    loading: true,
    method: 'get',
    data: params
  });
}

//用户list
export function getUserList(params) {
  return request(`${api.getUserList}`, {
    loading: true,
    method: 'get',
    data: params
  });
}

//供应商list
export function getSupplierList(params) {
  return request(`${api.getSupplierList}`, {
    loading: true,
    method: 'get',
    data: params
  });
}

//客户list
export function getCustomerList(params) {
  return request(`${api.getCustomerList}`, {
    loading: true,
    method: 'get',
    data: params
  });
}


//产品规格树
export function getProductTree(params) {
  return request(`${api.getProductTree}`, {
    loading: true,
    method: 'get',
    data: params
  });
}

export function uploadFile(params) {
  return fileRequest(`${api.uploadFile}`, {
    loading: true,
    headers: {'content-type': 'multipart/form-data'},
    method: 'post',
    data: params,
    promptMessage: "图像上传成功!",
  });
}


//可见公司待选列表
export function getVisibleCompanyList(params) {
  return request(`${api.getVisibleCompanyList}`, {
    loading: true,
    method: 'get',
  });
}




// WEBPACK FOOTER //
// ./src/services/common.js